export default "__VITE_ASSET__BvOdfo3j__"